import Gestion from "../Gestion/Gestion";
function AnalisisdeFinanciabilidadEmpresarial() {
  const textos = [
    ' En nuestra consultora jurídica brindamos un servicio integral de análisis de financiabilidad orientado a empresas, pymes y monotributistas que necesitan conocer, de manera clara y realista, qué opciones de financiamiento pueden acceder y en qué condiciones. ' ,
' Nuestro trabajo consiste en evaluar la situación legal, fiscal y patrimonial del cliente para determinar su capacidad efectiva de acceso al crédito, tanto en el sistema bancario como en alternativas privadas o institucionales. ' ,
 '¿Qué incluye el análisis? Revisión de la situación fiscal y registral, análisis de ingresos declarados y estructura jurídica, evaluación de riesgos y contingencias legales, identificación de límites reales de endeudamiento, recomendaciones para mejorar la elegibilidad crediticia ' ,
' ¿Para qué sirve? Evitar rechazos innecesarios o condiciones abusivas, tomar decisiones financieras con información concreta, ordenar la estructura legal antes de solicitar financiamiento, planificar crecimiento con respaldo jurídico ' ,
' ¿A quién está dirigido? Empresas en etapa de crecimiento, monotributistas que necesitan capital de trabajo, emprendedores que buscan financiamiento formal, negocios que desean regularizar su situación para acceder a crédito ' ,
' Nuestro enfoque es preventivo y estratégico: no prometemos financiamiento, sino diagnóstico serio, profesional y jurídicamente fundado, que permite saber dónde está parado el cliente y qué pasos dar. ' ,
' Invertir en un análisis previo ahorra tiempo, dinero y problemas futuros. '

  ];

  return (
    <>
      <Gestion titulo={"Análisis de Financiabilidad Empresaria"} textoServicio={textos}/>
    </>
  );
}

export default AnalisisdeFinanciabilidadEmpresarial;
